module.exports = __webpack_public_path__ + "static/media/pilot03.6a02cfb7.jpg";